/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Managepreferences1Inputs */



/**
* | output |
* | --- |
* | "Manage settings" |
*
* @param {Managepreferences1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const managepreferences1 = /** @type {((inputs?: Managepreferences1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Managepreferences1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manage settings")
	return /** @type {LocalizedString} */ ("Einstellungen verwalten")
});
export { managepreferences1 as "managePreferences" }